import React, { useRef } from 'react';
import styled from 'astroturf/react';
import { useOnClickOutside, useScrollLock } from 'js/utils/hooks';
import ToolsMenu, {
  Props as ToolsMenuProps,
} from 'js/header/FocusedNav/ToolsMenu';
import _Background from "ToolsSidebar-Background.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/ToolsSidebar.tsx?styleId=Background";
import _Container from "ToolsSidebar-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/ToolsSidebar.tsx?styleId=Container";


const Background = /*#__PURE__*/styled("div", null, {
  displayName: "Background",
  styles: _Background
});

const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

type Props = ToolsMenuProps & {
  close: () => void;
  buttonRef: React.RefObject<HTMLButtonElement>;
  navHeight: number;
};

const ToolsSidebar = ({ close, buttonRef, navHeight, ...restProps }: Props) => {
  useScrollLock();

  const containerRef = useRef<HTMLDivElement>(null);

  useOnClickOutside([buttonRef, containerRef], close);

  const onClose = (event: React.MouseEvent) => {
    if (event.target === event.currentTarget) {
      close();
    }
  };

  return (
    <Background
      onClick={onClose}
      style={{ height: `calc(100vh - ${navHeight}px)` }}
    >
      <Container ref={containerRef}>
        <ToolsMenu {...restProps} />
      </Container>
    </Background>
  );
};

export default ToolsSidebar;
